// src/components/leiaute/Header.js
import React, { useState } from 'react';
import { flushSync } from 'react-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { FiChevronDown, FiLogOut, FiMenu, FiUsers } from 'react-icons/fi';
import './Header.css'; // Arquivo CSS personalizado
import { useConfigModulo } from '../../contexts/administrativo/ConfigModuloContext';
import { useUser } from '../../contexts/geral/UserContext';
import { UsuarioPerfilLabel } from '../../models/geral/UsuarioPerfilEnum';



function Header({ toggleSideNav, isSideNavOpen, onOpenUsuario, onLogout }) {
  const { versao } = useConfigModulo();
  const { user } = useUser();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const nome = user?.nome?.trim() || user?.login?.trim() || 'Usuário';
  const partesNome = nome.split(/\s+/);
  const iniciais = `${partesNome[0][0]}${partesNome.length > 1 ? partesNome[partesNome.length - 1][0] : ''}`.toLocaleUpperCase('pt-BR');
  const perfil = user?.admin ? 'Administrador' : UsuarioPerfilLabel[user?.perfil] || 'Usuário';

  const handleUserAction = (action) => {
    // Conclui o retorno de foco do dropdown antes de abrir o cadastro.
    flushSync(() => setShowUserMenu(false));
    action();
  };

  return (
    <header className="header-menu">
      <div className="header-brand">
        <button
          id="sidenav-toggle"
          type="button"
          className="menu-toggle"
          aria-label={isSideNavOpen ? 'Fechar menu principal' : 'Abrir menu principal'}
          aria-expanded={isSideNavOpen}
          aria-controls="sidenav-menu"
          onClick={() => {
            setShowUserMenu(false);
            toggleSideNav();
          }}
        >
          <FiMenu aria-hidden="true" />
        </button>
        <div className="header-brand-text">
          <span className="header-title">Infomaio <span>ERP</span></span>
          <span className="header-subtitle">Menu Sistema</span>
        </div>
      </div>

      <div className="header-account">
        {versao && <span className="header-version">Versão {versao}</span>}
        <Dropdown show={showUserMenu} onToggle={setShowUserMenu} align="end">
          <Dropdown.Toggle
            id="header-user-menu"
            variant="link"
            className="header-user-toggle"
            aria-label={`Opções do usuário ${nome}`}
          >
            <span className="header-user-avatar" aria-hidden="true">{iniciais}</span>
            <span className="header-user-summary">
              <span className="header-user-name" title={nome}>{nome}</span>
              <span className="header-user-role">{perfil}</span>
            </span>
            <FiChevronDown className="header-user-chevron" aria-hidden="true" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="header-user-menu">
            <div className="header-user-details">
              <strong>{nome}</strong>
              <span>{perfil}{user?.login && ` · ${user.login}`}</span>
              {versao && <span className="header-user-version">Versão {versao}</span>}
            </div>
            <Dropdown.Divider />
            <Dropdown.Item as="button" onClick={() => handleUserAction(onOpenUsuario)}>
              <FiUsers aria-hidden="true" /> Cadastro de usuários
            </Dropdown.Item>
            <Dropdown.Item as="button" className="header-user-logout" onClick={() => handleUserAction(onLogout)}>
              <FiLogOut aria-hidden="true" /> Sair
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
}

export default Header;
